const initialState = {
    statusShow: false,
    statusAnimation: false,
    loader_modal: false,
    days: {},
    activeDayPostSchedule: '',
    activeSelectTablePostSchedule: {},
    statusLoaderPrice: false,

};
const modalEditOrderDateTime = (state = initialState, action) => {
    switch (action.type) {
        case "OPEN_MODAL_EDIT_DATE_TIME":
            return {...state, statusShow: true};
        case "CLOSE_MODAL_EDIT_DATE_TIME":
            return {...initialState, statusShow: false};
        case "TOGGLE_LOADER_MODAL_EDIT_ORDER_DELIVERY_DATE_TIME":
            return {...state, loader_modal: action.status};
        
        
        // case types.CHANGE_LOADER_LIST_PRODUCTS_MODAL_SHOPPING_CARD:
        //     return {...state, loaderListProducts: action.loaderListProducts};
        
        default:
            return state;
    }
};

export default modalEditOrderDateTime;
